export default "__VITE_ASSET__BQY6UhYc__"